// Block-level typography the Text/Table panels used to write and the floating
// toolbar no longer exposes. Tiptap only sees marks inside the content, so a block
// that already carries one of these keeps it with no control that can clear it.
export const INHERITED_TYPOGRAPHY_ATTRIBUTES = [
	'color',
	'font-family',
	'font-size',
	'font-weight',
	'font-style',
	'text-decoration',
	'text-transform',
	'white-space',
] as const;

export function getInheritedTypography(attributes?: Record<string, any> | null) {
	return INHERITED_TYPOGRAPHY_ATTRIBUTES.filter(name => {
		const value = attributes?.[name];
		return value !== undefined && value !== null && value !== '';
	});
}
